import React, { useState } from "react";
import helpIcon from "../../../../../assets/disabilityIcons/IC_Help.svg";
import { DisabilityFormCreator } from "../../../../../newComponents/V2Insurance/components/DisabilityFormCreator";
import CustomModal from "../../../../../components/styled-components/modal/custom-modal/custom-modal";
import CollapseableTable from "../../components/collapseAbleTable/CollapseableTable";
import MenuIcon from "../../../../../assets/disabilityIcons/Menu.svg";
import { Table } from "antd";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import useGetAttributes from "../../hooks/useGetAttributes";
import NewLoader from "../../../../../components/styled-components/loader/NewLoader";
import useCreateAttribute from "../../hooks/useCreateAttribute";
import UseUpdate from "../../hooks/UseUpdate";
import useDeleteItem from "../../hooks/useDeleteItem";
import useModuleData from "../../hooks/useFetchItems";
import { EmergencyColumns } from "./AllColumnsData";
import useModalHandlers from "../../hooks/useModalHandler";
import useFetchContacts from "../../hooks/useFetchContacts";
import { ToolTipCreator } from "../../../../../helpers/ToolTipCreator";


const moduleNames = [
  "Emergency Contacts",
  "Family Contacts (local)",
  "Family Contacts (distant)",
  "Insurance Agents",
  "Utility Companies",
  "Local Emergency Management Office",
  "Evacuation Centers",
  "Pet Emergency Contacts/Shelters",
];
export default function EmergencyContacts() {
  const [loading, setLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [moduleName, setModuleName] = useState("Emergency Contacts");
  const [formData, setFormData] = useState(null);

  const [attributesData, setAttributesData] = useState(null);

  const history = useHistory();
  const {
    fetchData,
    disasterAttributeData,
    formatModuleKey,
    setTableData,
    setToUpdate,
    toUpdate,
    tableData,
  } = useModuleData(moduleNames, setLoading);
  const { createAttributes } = useCreateAttribute(
    moduleName,
    formData,
    setFormData,
    setToUpdate,
    fetchData,
    formatModuleKey,
    setTableData,
    setLoading
  );
  const { updateRecord } = UseUpdate(
    formData,
    setFormData,
    fetchData,
    formatModuleKey,
    setTableData,
    setLoading
  );
  const { deleteRecord } = useDeleteItem(fetchData, formatModuleKey, setTableData, setLoading);
  const { attributes, disasterAttribute } = useGetAttributes(moduleNames, setLoading);
  const { showModal, updateModal, viewModal, handelCloseModal } = useModalHandlers(
    attributes,
    setModalTitle,
    setModuleName,
    setIsModalVisible,
    setFormData,
    setAttributesData
  );

  console.log("modsal to veiew data",attributes,modalTitle,moduleName,formData,attributesData,disasterAttribute)

  const { contactList } = useFetchContacts(setLoading);

  //console.log("formData", formData);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleItemsInfoSelect = (name, value) => {
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  console.log("formdataemergency",formData);
  const handleFormDataUpdate = (formData) => {
    const Payload = {
      "Name": formData && formData.name,
      "Phone Number": formData && formData.phoneNumber,
      "Relationship": formData.typeOfRelation,
      "Street": formData.homeStreet,
      "State": formData.homeState,
      "City": formData.homeCity,
      "Company":formData.jobCompany,
    };

    console.log("Payload to update formData emergency contacts:", Payload);

    setFormData((prev) => ({
      ...prev,
      ...Payload,
    }));
  };
  // If your data properties have different names:
  const tableDataObj = {
    "Family Contacts (Local)": tableData.familyContactsLocalData,
    "Family Contacts (Distant)":tableData.familyContactsDistantData,
    "Insurance Agents":tableData.insuranceAgentsData,
    "Utility Companies": tableData.utilityCompaniesData,
    "Local Emergency Management Office": tableData.localEmergencyManagementOfficeData,
    "Evacuation Centers": tableData.evacuationCentersData,
    "Pet Emergency Contacts/Shelters": tableData.petEmergencyContactsSheltersData,
  };
  const columnsData = EmergencyColumns(viewModal, updateModal, deleteRecord);
  const collapseableTables = [
    { title: "Family Contacts (Local)", key: 1 },
    { title: "Family Contacts (Distant)", key: 2 },
    { title: "Insurance Agents", key: 3 },
    { title: "Utility Companies", key: 4 },
    { title: "Local Emergency Management Office", key: 5 },
    { title: "Evacuation Centers", key: 6 },
    { title: "Pet Emergency Contacts/Shelters", key: 7 },
  ];
  const AddContact = () => {
    history.push("/client/plan");
  };
  console.log("formData",formData)
  return (
    <div style={{ position: "relative" }}>
      <div className="parent-title-container">
      <div style={{display:'flex', alignItems:'baseline', columnGap:'3px'}}>
        <h2 className="parent-title">Emergency Contacts</h2>
        <ToolTipCreator name={"Disaster_Emergency_Contacts"}/>
      </div>
        {/* <div className="parent-icon-container">
          <img src={helpIcon} alt="help icon" width="18.67px" height="18.67px" />
        </div> */}
      </div>
      {disasterAttribute && (
        <>
          <DisabilityFormCreator
            data={disasterAttribute && disasterAttribute}
            values={disasterAttributeData && disasterAttributeData}
            setSubmitBody={setFormData}
          />
          <div className="handle-submit-button-container">
            <button
              className="submit-button"
              onClick={async () => {
                if (toUpdate) {
                  await updateRecord();
                } else {
                  if (formData && Object.keys(formData).length > 0) {
                  await createAttributes();
                  }
                }
              }}
            >
              {toUpdate ? "Update" : "Submit"}
            </button>
          </div>
        </>
      )}
      <div>
        <CustomModal
          show={isModalVisible}
          fields={attributesData && attributesData}
          modalTitle={modalTitle}
          close={handelCloseModal}
          onChange={handleChange}
          onSelectChange={handleItemsInfoSelect}
          submitData={modalTitle !== "Update" ? createAttributes : updateRecord}
          selectedRowData={formData && formData}
          handleItemsInfoImageChange={formData}
          loading={loading}
        />
      </div>
      {collapseableTables.map((table, idx) => (
        <CollapseableTable
          title={table.title}
          key={table.key}
          setFormData={setFormData}
          formData={formData}
          setModuleName={setModuleName}
          handleFormDataUpdate={handleFormDataUpdate}
          // createAttributes={createAttributes}
           createAttributes={async () => {
              if (formData && Object.keys(formData).length > 0) {
                await createAttributes();
              }
            }}
          onClick={() =>
            ["Family Contacts (Local)", "Family Contacts (Distant)", "Insurance Agents"].includes(table.title)
              ? AddContact()
              : showModal(table.title)
          }
          showDropDown={table.key === 3 && true}

          options={contactList}
        >
          <Table columns={columnsData[table.title]} dataSource={tableDataObj[table.title]} />
        </CollapseableTable>
      ))}
      <NewLoader isLoading={loading} />
    </div>
  );
}
